var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('vue-headful',{attrs:{"title":"ePlato"}}),_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }